"use client"
import { CourseDetailView } from '@/pages/courses/sections/detail/course-detail'

export default function CourseDetailPage(){
  return <CourseDetailView />
}
